import { call, put, select, takeEvery } from 'redux-saga/effects'

import amplitude from '@lib/analytics/amplitude'
import { AnalyticsTrackingActionTypes, trackEvent, trackEventSuccess } from '@store/analytics'
import { shouldUserTrackEvents } from '@store/me'

export function* handleTrackingRequest(action: ReturnType<typeof trackEvent>) {
  const { payload } = action
  const { name, properties } = payload
  const shouldTrackEvents = yield select(shouldUserTrackEvents)

  if (shouldTrackEvents) {
    yield call(amplitude.track, name, properties)
    yield put(trackEventSuccess(name, properties))
  }
}

export function* watchTrackingRequest() {
  yield takeEvery(AnalyticsTrackingActionTypes.SEND_TRACKING_REQUEST, handleTrackingRequest)
}
